module.exports = __webpack_public_path__ + "static/img/12-货拉拉.e58360a2.png";